/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 9/3/2022
 */

export const WorkflowStateEnum = Object.freeze({
	NOT_SET: "NOT_SET",
	INITIAL: "INITIAL",
	FOLLOWUP_30_60_90_IMPAIRMENTS: "FOLLOWUP_30_IMPAIRMENTS",
	FOLLOWUP_30_90_IMPAIRMENTS: "FOLLOWUP_60_IMPAIRMENTS",
	NEEDS_COMPLETION: "NEEDS_COMPLETION",
	FOLLOWUP_30_SAFETY_RISK: "FOLLOWUP_30_SAFETY_RISK",
	SAFETY_RISK_COMPLETED_SOME_CONCERNS: "SAFETY_RISK_COMPLETED_SOME_CONCERNS",
	SAFETY_RISK_COMPLETED: "SAFETY_RISK_COMPLETED",
	FOLLOWUP_90: "FOLLOWUP_90",
	ESCALATED_CARE: "ESCALATED_CARE",
	ESCALATED_CARE_COMPLETED: "ESCALATED_CARE_COMPLETED",
})
